import { createContext } from 'react';
import type { TierGateContextValue } from '@/interfaces/api/tierGates';

export const TierGateContext = createContext<TierGateContextValue>({
  gates: {},
  isLoading: true,
  error: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  refresh: () => {},
});
